const question3 = {
    'question': 'Czy diagnozę autyzmu można wykonać tylko u dziecka?',
    'answer': 'Nie, diagnozę autyzmu w naszym centrum w Toruniu można wykonać również u dorosłych. W rzeczywistości coraz więcej osób dorosłych jest diagnozowanych z autyzmem. Dzieje się tak, ponieważ świadomość autyzmu rośnie i ludzie są bardziej świadomi objawów.',
}

export default question3;